import { TableTry } from "@/components";
// import CustomTable from "@/components/Table";
import TransactionsAdmin from "@/components/TransactionsAdmin";
import { getUser } from "@/utils/localStorage";
import React from "react";

const Transactions: React.FC = () => {

  const user = getUser();
  const isAdmin = user?.is_staff;

  return isAdmin ? <TransactionsAdmin /> : <TableTry title="Transactions" />

};

export default Transactions;
